var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDragDropBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 6C3 6.55228 3.44772 7 4 7C4.55228 7 5 6.55228 5 6C5 5.44772 4.55228 5 4 5C3.44772 5 3 5.44772 3 6Z",
    fill: "#149CCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.66699C3 10.2193 3.44772 10.667 4 10.667C4.55228 10.667 5 10.2193 5 9.66699C5 9.11471 4.55228 8.66699 4 8.66699C3.44772 8.66699 3 9.11471 3 9.66699Z",
    fill: "#149CCE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 6C7 6.55228 7.44772 7 8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5C7.44772 5 7 5.44772 7 6Z",
    fill: "#149CCE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.66699C7 10.2193 7.44772 10.667 8 10.667C8.55228 10.667 9 10.2193 9 9.66699C9 9.11471 8.55228 8.66699 8 8.66699C7.44772 8.66699 7 9.11471 7 9.66699Z",
    fill: "#149CCE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11 6C11 6.55228 11.4477 7 12 7C12.5523 7 13 6.55228 13 6C13 5.44772 12.5523 5 12 5C11.4477 5 11 5.44772 11 6Z",
    fill: "#149CCE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M15 6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6C17 5.44772 16.5523 5 16 5C15.4477 5 15 5.44772 15 6Z",
    fill: "#149CCE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11 9.66699C11 10.2193 11.4477 10.667 12 10.667C12.5523 10.667 13 10.2193 13 9.66699C13 9.11471 12.5523 8.66699 12 8.66699C11.4477 8.66699 11 9.11471 11 9.66699Z",
    fill: "#149CCE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M15 9.66699C15 10.2193 15.4477 10.667 16 10.667C16.5523 10.667 17 10.2193 17 9.66699C17 9.11471 16.5523 8.66699 16 8.66699C15.4477 8.66699 15 9.11471 15 9.66699Z",
    fill: "#149CCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDragDropBlue);
export default __webpack_public_path__ + "static/media/dragDropBlue.2365108554d6cad594cfb59f43686b66.svg";
export { ForwardRef as ReactComponent };